// German-style dates (10.10.2026) and 24-hour times (15:00), the same in every
// browser regardless of its language settings.

function toDate(value) {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

const pad = (number) => String(number).padStart(2, '0');

// 10.10.2026 (or 10.10.26 with shortYear)
export function formatDate(value, { shortYear = false } = {}) {
  const date = toDate(value);
  if (!date) return '';
  const year = shortYear ? pad(date.getFullYear() % 100) : date.getFullYear();
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${year}`;
}

// 15:00
export function formatTime(value) {
  const date = toDate(value);
  if (!date) return '';
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

// 10.10.2026 ✶ 15:00
export function formatDateTime(value) {
  const date = toDate(value);
  if (!date) return '';
  return `${formatDate(date)} ✶ ${formatTime(date)}`;
}

// 10.10.2026 ✶ 15:00–18:00 when there's an end time, otherwise as above.
export function formatDateTimeRange(start, end) {
  const from = formatDateTime(start);
  const until = end ? formatTime(end) : '';
  return from && until ? `${from}–${until}` : from;
}
